import { actionTypes as types } from './constants';

export const fetchFeatured = () => ({
    type: types.FETCH_FEATURED_START
});
